import Header from './Header';
import Footer from './Footer';
import Body from './Body';

function App() {
    return (
        <>
            <Header/>
            <Body/>
            <Footer/>
        </>
    );
}

export default App;
